import React from "react";
import "./style.css";
import img from "../../../Assets/Images/Swish&Wish.png";
import {
  MEDIA_LINKS,
  COMMON_THUMBNAIL_URL,
} from "../../../Constants/mediaLinks";

const FlyerComponent = () => {
  return (
    <div className="flyer-container">
      <div className="flyer-section">
        <img
          src={img} // Use curly braces to reference the imported image
          alt="Swish & Wish Fundraising Flyer"
          className="flyer-image filter-brightness"
        />
      </div>
      <div className="video-section">
        <div className="video-player">
          <div
            style={{
              position: "relative",
              width: "100%",
              paddingBottom: "56.25%",
            }}
          >
            <video
              controls
              autoPlay
              muted
              poster={MEDIA_LINKS.FUND_RAISING.VIDEO_01}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            >
              <source
                src={MEDIA_LINKS.FUND_RAISING.VIDEO_01}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlyerComponent;
